/** Payload QR para configurar la app Android NFC Kiosco (v1). */
export function buildKioskQrPayload(apiUrl, token) {
  const api = (apiUrl || "").trim().replace(/\/$/, "");
  const tok = (token || "").trim();
  if (!api || !tok) return "";
  return JSON.stringify({
    v: 1,
    app: "control_horario_kiosco",
    api,
    token: tok,
  });
}

export function defaultKioskApiUrl(origin = window.location.origin) {
  return `${origin.replace(/\/$/, "")}/api`;
}
